import React from "react";
import { BankAccountsList } from "../components/BankAccountsList";
import { DuplicateThresholdCard } from "../components/DuplicateThresholdCard";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * BanksPage — `/settings/banks`.
 *
 * The company's own bank, cash and credit-card accounts. A setting rather than
 * a report: these rows decide which accounts appear in every payment picker,
 * which ones the cash dashboard totals, and which statements can be uploaded at
 * all. The balances beside them are context, not the subject.
 *
 * Cash & Bank shows the same accounts and is where transactions get worked. The
 * difference is what each screen is for — that one asks "what happened on this
 * account", this one asks "is this account set up right".
 *
 * ZOUR-87 added the first setting here that is not about one account: the
 * duplicate-narration threshold the statement review screen grades against.
 */
export const BanksPage: React.FC = () => (
  <SettingsLayout>
    <SettingsManagedPanel
      title="Banks"
      description="The accounts your books are kept against. Adding one here creates it in Zoho Books too."
    >
      <div className="flex w-full flex-col gap-6">
        <BankAccountsList />
        <DuplicateThresholdCard />
      </div>
    </SettingsManagedPanel>
  </SettingsLayout>
);
